import React from 'react';
import { ELeadResponseType } from 'types/lead-response';

import { Dialog } from '@material-ui/core';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';

import AgentLandingLeadForm, {
  normalizeAgents,
  valuationReportRequestOptions,
} from 'components/AgentLanding/AgentLandingPrimitives';

const ContactModal = ({
  onClose, agentLandingPageToken, agentData, variant = 'question',
}) => {
  const isTeam = normalizeAgents(agentData).length > 1;
  const isReportDiscussion = variant === 'report';

  return (
    <Dialog
      aria-label={isReportDiscussion ? 'Discuss your property report' : 'Ask your real estate advisor a question'}
      BackdropProps={{ className: 'al-contact-modal-backdrop' }}
      classes={{ root: 'al-contact-dialog', paper: 'al-contact-modal-paper' }}
      fullWidth
      open
      keepMounted
      maxWidth="md"
      scroll="paper"
      onClose={onClose}
    >
      <button
        className="al-contact-modal-close"
        type="button"
        aria-label="Close"
        onClick={onClose}
      >
        <CloseRoundedIcon aria-hidden="true" />
      </button>
      <AgentLandingLeadForm
        agentLandingPageToken={agentLandingPageToken}
        agentData={agentData}
        className="al-contact-modal-form"
        leadResponseType={ELeadResponseType.AgentLandingPropertyReviewRequest}
        title={isReportDiscussion ? 'Let’s talk through your report.' : `Ask ${isTeam ? 'us' : 'me'} a question.`}
        subtitle={isReportDiscussion
          ? `${isTeam ? 'We’ll' : 'I’ll'} help you understand what the data means for your property and your next move.`
          : 'Share the property and question you have in mind.'}
        submitLabel={isReportDiscussion ? 'Discuss my report' : 'Send my question'}
        successTitle={isReportDiscussion
          ? 'Thank you — your report discussion request is on its way.'
          : 'Thank you — your question is on its way.'}
        successMessage={isReportDiscussion
          ? `${isTeam ? 'We’ll' : 'I’ll'} review your report context and follow up to talk through the numbers.`
          : `${isTeam ? 'We’ll' : 'I’ll'} review your question and respond personally.`}
        stepLabel={isReportDiscussion ? 'Personal guidance, no pressure' : 'A direct line to your advisor'}
        privacyText="Your information is private and will never be shared or sold."
        formVariant={isReportDiscussion ? 'report' : 'default'}
        requestOptions={isReportDiscussion ? valuationReportRequestOptions : undefined}
        showPropertyAddress={!isReportDiscussion}
        showSellingTimeline={!isReportDiscussion}
        showMessage
      />
    </Dialog>
  );
};

export default ContactModal;
